export enum PlanOfferings {
  POWERON_PRO = 'PowerOn Pro',
  POWERON_PRO_PLUS = 'PowerOn Pro+',
  POWERON_PIPELINES = 'PowerOn Pipelines',
  GLACI = 'Glaci',
  GLACI_FREE = 'Glaci (Free)',
  NEXUM_SELF_HOSTED = 'NaaS (Self-hosted)',
  NEXUM_LIBUM_HOSTED = 'NaaS (Libum-hosted)',
}
